import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    text-align: center;
    box-sizing:border-box;
    background: #171c28;
    color:#fff;
    margin: 0;
    padding: 0;
    font-family: Edu QLD Beginner;
    font-weight: 700;
  }
  
  .burger img {
  display: none;
}

@media (max-width: 768px) {
  .burger img {
    display: block;
  }
}
#snow_light {
   height: 100%;
   left: 0;
   pointer-events: none;
   position: fixed;
   top: 0;
   width: 100%;
   z-index: 99999;
   }
`;


 
export default GlobalStyle;